<ul class="app-task-list app-task-list__items">
  <li *ngFor="let section of sections" netz-task-section [title]="section.title" [tasks]="section.tasks"></li>
  <ng-content></ng-content>
</ul>
